import React, { useEffect, useState } from "react";
import userModule from "../Apis/userModule";
import { useForm } from "react-hook-form";
import { notifySuccess, notifyError } from "../utils/toast"; 
import { handleGetAllUsers, handleUpdateUserById } from "../services/userService";
import { userID } from "../utils/storage";

const useUser = () => {
  const {
    register,
    handleSubmit,
    formState: { errors },
    watch,
    reset,
  } = useForm();

  const [user, setUser] = useState(null);
  const [userCache, setUserCache] = useState(new Map());
  const [prevIdStack, setPrevIdStack] = useState([]);
  const [openStatus, setOpenStatus] = useState(false);
  const [loading, setLoading] = useState(false);
  const [visible, setVisible] = useState(false);
  const [exiting, setExiting] = useState(false);
  const [userForm, setUserForm] = useState({});
  const [limit, setLimit] = useState(10);
  const [nextId, setNextId] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [searchKey, setSearchKey] = useState("");
  const [activeStatus, setActiveStatus] = useState(false);
  const [userResignCount, setUserResignCount] = useState(0);
  const [pendingDeactivation, setPendingDeactivation] = useState(null); // Store userId for deactivation
  const [loading2 , setLoading2] = useState(false);
  const [hasMore , setHasMore] = useState(false);

  const getUserData = async (
    searchKey,
    cursor,
    limit,
    isBack = false,
    pageNumber = currentPage
  ) => {
    setLoading(true);

    if (isBack && userCache.has(pageNumber)) {
      setUser(userCache.get(pageNumber));
      setLoading(false);
      return;
    }

    const options = {
      limitCount: limit,
      searchKey: searchKey,
      startAfterdoc: cursor,
    };

    try {
      const response = await handleGetAllUsers(options);
      const users = response?.users || [];
      console.log("User Response ", response);

      const receivedFullPage = users.length === limit;
      const hasMoreData = receivedFullPage && !!response.lastDoc;
      setHasMore(hasMoreData)

      console.log("hasMoreData" , hasMoreData)


      setUser(users);
      setNextId(response?.lastDoc);
      setActiveStatus(response.users?.status);

      setUserCache((prev) => new Map(prev).set(pageNumber, users));
    } catch (error) {
      console.log(error);
      setUser([]);
    } finally {
      setLoading(false);
    }
  };

  const handlePageChange = (cursor, direction) => {
    if (direction === "next") {
      const nextPage = currentPage + 1;
      setCurrentPage(nextPage);

      if (userCache.has(nextPage)) {
        setUser(userCache.get(nextPage));
      } else {
        getUserData(searchKey, nextId, limit, false, nextPage);
      }
    } else if (direction === "previous" && currentPage > 1) {
      const prevPage = currentPage - 1;
      const newStack = [...prevIdStack];
      const prevCursor = newStack.pop();
      setPrevIdStack(newStack);
      setCurrentPage(prevPage);

      if (userCache.has(prevPage)) {
        setUser(userCache.get(prevPage));
        const nextPageData = userCache.get(prevPage + 0 );
        console.log(nextPageData)
        setHasMore(!!nextPageData && nextPageData.length >= limit);
      } else {
        getUserData(searchKey, prevCursor, limit, true, prevPage);
      }
    }
  };

  const handlePageSize = (value) => {
    setLimit(value);
    setCurrentPage(1);
    setPrevIdStack([]);
    setUserCache(new Map());
    setNextId("");
    getUserData(searchKey, "", value, false, 1);
  };

  const handleStatus = async (userId) => {
    try {
      const body = {
        userId: userId,
      };
      setVisible(false); 
      setLoading2(true)
      const response = await userModule.checkUserDeative(body);
      console.log(response);
      if (response.status === 200) {
        setUserResignCount(response.data?.count || 0);
        setPendingDeactivation({ userId });
        setOpenStatus(true); 
       
      } 
    } catch (error) {
      console.log(error);
      notifyError("Error validating user for deactivation");
    }finally{
      setLoading2(false)
    }
  };

  const handleDeactiveUser = async () => {
    const { userId } = pendingDeactivation;
    setOpenStatus(false);
    setVisible(false);
  setLoading(true)

    try {
      const response = await handleUpdateUserById(userId, {
        status: false,
        modifiedBy: userID,
      });
      console.log(response)
      notifySuccess("Successfully Deactivated User");
      setPendingDeactivation(null); 
      setPrevIdStack([]);
      setUserCache(new Map());
      getUserData(searchKey, "", limit, false, 1);
    } catch (error) {
      console.log(error);
      notifyError("Failed to deactivate user");
    }finally{
      setLoading(false)
    }
  };

  const handleSearchSubmit = (e) => {
    e.preventDefault();
    setCurrentPage(1);
    setPrevIdStack([]);
    setUserCache(new Map());
    getUserData(searchKey, "", limit, false, 1);
  };

  const handleUserManage = async (data) => {

    setLoading(true);

    try {
      if (data?.id) {
        const response = await handleUpdateUserById(data.id, {
          name: data.name,
          phoneNumber: data.phoneNumber,
          modifiedBy: userID,
        });
      
        reset();
        notifySuccess("User updated successfully");

      } else {
        const response = await userModule.createUser({
          name: data.name,
          email: data.email,
          phoneNumber: data.phoneNumber,
          role: data.role,
          createdById: userID,
        });
        if (response.status === 200) {
          notifySuccess(response?.data);
          reset();
        }
      }
      setVisible(false);
      setPrevIdStack([]);
      setUserCache(new Map());
      getUserData(searchKey, "", limit, false, 1);
      return;
    } catch (error) {
      
      if(error.response?.status === 409)
      {
        notifyError(error?.response?.data);
      }else{
        if (error.code === "DUPLICATE_PHONE") {
          notifyError(error.message);
        } else {
          notifyError("An unexpected error occurred.");
        }
      }
      
    } finally {
      setLoading(false);
    }
  };

  const handleExitingData = async (data) => {
    setVisible(true);
    setExiting(true);
    reset({ ...data, id: data.id });
  };

  const handleToggle = () => {
    reset({ name: "" });
    setVisible(!visible);
  };

  useEffect(() => {
    getUserData(searchKey, "", limit, false, 1);
  }, [limit]);

  return {
    reset,
    user,
    loading,
    userForm,
    setUserForm,
    setUser,
    setLoading,
    register,
    handleSubmit,
    errors,
    watch,
    handleUserManage,
    handleExitingData,
    visible,
    setVisible,
    exiting,
    setExiting,
    handleToggle,
    handleSearchSubmit,
    setSearchKey,
    searchKey,
    setLimit,
    limit,
    currentPage,
    setCurrentPage,
    nextId,
    handlePageChange,
    handlePageSize,
    handleStatus,
    openStatus,
    setOpenStatus,
    handleDeactiveUser,
    userResignCount,
    loading2,
    hasMore
  };
};

export default useUser;